var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevels(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04 4.095A1.548 1.548 0 108.04 1a1.548 1.548 0 000 3.095zM2.881 13.38a1.548 1.548 0 100-3.095 1.548 1.548 0 000 3.095zM8.04 13.38a1.548 1.548 0 100-3.095 1.548 1.548 0 000 3.095zM13.198 13.38a1.548 1.548 0 100-3.095 1.548 1.548 0 000 3.095z",
    stroke: "#525059",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88 10.285V8.222A1.032 1.032 0 013.914 7.19h8.253a1.032 1.032 0 011.031 1.032v2.063M8.04 4.095v6.19",
    stroke: "#525059",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgLevels;